import { createSelector } from "reselect";

const UPDATE_SHIPPING_VENDOR = "UPDATE_SHIPPING_VENDOR";
const CLEAR_SHPPING = "CLEAR_SHPPING";

const initialState = {
  isVendor: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "FLUSH":
    case CLEAR_SHPPING:
      return initialState;

    case UPDATE_SHIPPING_VENDOR:
      return {
        ...state,
        isVendor: action.isVendor,
      };

    default:
      return state;
  }
}

export function setIsShippingVendor(isVendor) {
  return {
    type: UPDATE_SHIPPING_VENDOR,
    isVendor,
  };
}

export const getVendorState = (state) => state.shipping;

export const getVendorStatus = createSelector(
  getVendorState,
  (shipping) => shipping?.isVendor,
);
